<template>
    <div
        v-tooltip="{
            content: tooltipHtml,
            html: true,
        }"
        class="arv-compliance-bar"
    >
        <div class="arv-compliance-bar__values">
            <span
                class="arv-compliance-bar__current"
                :class="{
                    'arv-compliance-bar__current--exceeded': exceeded,
                }"
            >
                {{ value }}{{ unit }}
            </span>
            <span class="arv-compliance-bar__max">/{{ max }}{{ unit }}</span>
        </div>
        <div class="arv-compliance-bar__track">
            <div
                class="arv-compliance-bar__fill"
                :class="fillClass"
                :style="{ width: barWidth + '%' }"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'EcoScoreArvComplianceBar',
    props: {
        value: {
            type: Number,
            required: true,
        },
        max: {
            type: Number,
            required: true,
        },
        unit: {
            type: String,
            default: 'h',
        },
        label: {
            type: String,
            required: true,
        },
    },
    computed: {
        pct() {
            return Math.min((this.value / this.max) * 100, 100)
        },
        exceeded() {
            return this.value > this.max
        },
        barWidth() {
            return Math.min(this.pct, 100)
        },
        fillClass() {
            if (this.pct >= 90) {
                return 'arv-compliance-bar__fill--danger'
            }
            if (this.pct >= 80) {
                return 'arv-compliance-bar__fill--warning'
            }
            return 'arv-compliance-bar__fill--ok'
        },
        tooltipHtml() {
            let html = `<strong>${this.label}</strong><br>`
            html += `${this.value}${this.unit} / ${this.max}${
                this.unit
            } (${Math.round(this.pct)}%)`
            if (this.exceeded) {
                html += `<br><span style="color:#cc3333;font-weight:600">⚠ ${this.$t(
                    'exceeded'
                )}</span>`
            }
            return html
        },
    },
}
</script>

<i18n>
{
    "en": {
        "exceeded": "Limit exceeded!"
    },
    "de": {
        "exceeded": "Limit überschritten!"
    },
    "fr": {
        "exceeded": "Limite dépassée !"
    },
    "it": {
        "exceeded": "Limite superato!"
    }
}
</i18n>

<style lang="scss" scoped>
.arv-compliance-bar {
    min-width: 100px;

    &__values {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        gap: 0.25rem;
        margin-bottom: 0.125rem;
    }

    &__current {
        font-size: 0.75rem;
        font-weight: 600;
        font-variant-numeric: tabular-nums;
        color: $color-text;

        &--exceeded {
            color: #cc3333;
        }
    }

    &__max {
        font-size: 0.625rem;
        color: $color-gray-darker;
    }

    &__track {
        height: 0.375rem;
        width: 100%;
        border-radius: 999px;
        background-color: $color-gray-light;
        overflow: hidden;
    }

    &__fill {
        height: 100%;
        border-radius: 999px;
        transition: width 0.3s ease;

        &--ok {
            background-color: #339966;
        }

        &--warning {
            background-color: #e5a100;
        }

        &--danger {
            background-color: #cc3333;
        }
    }
}
</style>
